import { Location } from "@angular/common"
import { Component, OnInit } from "@angular/core"
import { NgForm } from "@angular/forms"
import { MdSnackBar } from "@angular/material"
import { ActivatedRoute, Params, Router } from "@angular/router"

import { DisplayService } from "../../display.service"
import { Merchant } from "../../shared/merchant"
import { MerchantImageUrl } from "../../shared/merchant-image-url"
import { MerchantReferralCampaignPages, MerchantReferralCampaignPagesTemplate } from "../../shared/merchant-referral"
import { ToolService } from "../../tool.service"
import { AdvocateReferralForm } from "../advocate-referral-form"
import { ReferralService } from "../referral.service"

@Component({
  selector: "app-merchant",
  templateUrl: "./merchant.component.html",
  styleUrls: ["./merchant.component.scss"]
})
export class ReferralMagicMerchantComponent implements OnInit {
  // Route variables
  merchant_slug: string

  // Local variables
  advocate_url: string
  advocate_code: string
  cover_image: MerchantImageUrl
  email_url: string
  error: string
  facebook_url: string
  is_enabled: boolean
  merchant: Merchant
  model: AdvocateReferralForm = {
    name: "",
    email: ""
  }
  pages: MerchantReferralCampaignPages
  patterns: Object
  promo_code: string
  template: MerchantReferralCampaignPagesTemplate
  twitter_url: string
  type: string

  constructor(
    private displayService: DisplayService,
    private referralService: ReferralService,
    private toolService: ToolService,
    private location: Location,
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MdSnackBar
  ) {}

  ngOnInit() {
    this.route.queryParams.forEach((params: Params) => {
      this.displayService.setEmbedded(params.hasOwnProperty("embed"))
      this.displayService.setModal(params.hasOwnProperty("modal"))

      this.patterns = {
        email: this.toolService.EMAIL_VALIDATION_REGEX,
        phone: this.toolService.PHONE_VALIDATION_REGEX
      }

      if (params["name"]) {
        this.model.name = params["name"]
      }

      if (params["email"]) {
        this.model.email = params["email"]
      }

      if (params["i"]) {
        this.model.invite_id = params["i"]
      }
    })

    this.route.params.forEach((params: Params) => {
      this.merchant_slug = params["merchant_slug"]
      this.referralService
        .getMerchant(this.merchant_slug)
        .then((merchant) => {
          this.merchant = merchant
          this.advocate_code = this.toolService.getItemFromLocalStorage(`${this.merchant_slug}:advocate_code`)

          if (
            this.merchant.settings.referral_magic &&
            this.merchant.settings.referral_magic.enabled &&
            this.merchant.referral_program
          ) {
            this.pages = this.merchant.referral_program.pages
            this.template = this.referralService.loadTemplateDynamicValues(
              this.pages.templates["advocate_signup"],
              merchant
            )
            this.is_enabled = true
            this.displayService.setReferralMagicPageStyles(this.pages)
            if (this.template.show_cover !== true) {
              this.cover_image = null
            } else if (this.template.cover_url) {
              this.cover_image = this.template.cover_url
            } else if (this.merchant.referral_program.pages.cover_url) {
              this.cover_image = this.merchant.referral_program.pages.cover_url
            }

            if (this.advocate_code) {
              const advocate_authorization_token = this.toolService.getItemFromLocalStorage(
                `${this.merchant_slug}:advocate_authorization_token`
              )
              this.goToAdvocateSharingPage(this.advocate_code, advocate_authorization_token)
              return
            } else if (this.model.invite_id) {
              return this.referralService
                .getAdvocateInvite(this.merchant.id, this.model.invite_id)
                .then((referral_invite) => {
                  if (referral_invite.advocate) {
                    this.goToAdvocateSharingPage(
                      referral_invite.advocate.referrer_code,
                      referral_invite.advocate.referrer_authorization_token
                    )
                    return
                  }

                  this.model.name = referral_invite.customer.name
                  switch (referral_invite.customer.contact_type) {
                    case "email":
                      this.model.email = referral_invite.customer.contact
                      break
                    case "phone":
                      this.model.mobile = referral_invite.customer.contact
                      break
                  }
                })
            }
          } else {
            this.is_enabled = false
          }
        })
        .catch((error) => {
          if (error.status_code === 404) {
            window.location.href = "https://onelocal.com/404"
          } else {
            this.error = error
          }
        })
        .then(() => {
          this.displayService.setApplicationLoaded()
        })
    })
  }

  onSubmit(advocateSignUpForm: NgForm) {
    if (advocateSignUpForm.valid) {
      this.error = null
      this.referralService.createAdvocate(this.merchant_slug, this.model).then(
        (advocate_info) => {
          this.snackBar.open("Success!", null, { duration: 2000 })
          this.toolService.setItemInLocalStorage(`${this.merchant_slug}:advocate_code`, advocate_info.referrer_code)
          this.goToAdvocateSharingPage(advocate_info.referrer_code, advocate_info.referrer_authorization_token)
        },
        (error) => {
          this.error = error.message
        }
      )
    }
  }

  goToAdvocateSharingPage(referrer_code: string, authorization_token?: string) {
    if (referrer_code) {
      const queryParams = {}

      if (this.displayService.is_embedded) {
        queryParams["embed"] = ""
      }

      if (this.displayService.is_modal) {
        queryParams["modal"] = ""
      }

      const route_segments = [this.merchant_slug, referrer_code]

      if (authorization_token) {
        route_segments.push(authorization_token)
      }

      this.router.navigate(route_segments, { queryParams })
      return
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/referral-magic/merchant/merchant.component.ts